"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInterface = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const Header_1 = __importDefault(require("../Header"));
const LeftSidebar_1 = __importDefault(require("../LeftSidebar"));
const MainCanvas_1 = __importDefault(require("../MainCanvas"));
const RightSidebar_1 = __importDefault(require("../RightSidebar"));
const useFormBuilderLogic_1 = require("./hooks/useFormBuilderLogic");
const SchemaSettings_1 = require("./components/SchemaSettings");
const FormSettingsContext_1 = require("../../context/FormSettingsContext");
const buildPrompt_1 = require("../../utils/buildPrompt");
const api_1 = require("../../api");
const UserInterface = ({}) => {
    (0, useFormBuilderLogic_1.useFormBuilderLogic)();
    const { generatedCode, selectedForm, currentSchema } = (0, FormSettingsContext_1.useFormSetting)();
    const buildPromptWrraper = (0, react_1.useCallback)((text, options) => (0, buildPrompt_1.buildPrompt)(api_1.DOC_TYPE.FORM, text, Object.assign({ generatedCode }, options)), [generatedCode]);
    const getSessionValuesToUpdate = (0, react_1.useCallback)(() => {
        var _a;
        return ({
            formId: (_a = selectedForm === null || selectedForm === void 0 ? void 0 : selectedForm._id) !== null && _a !== void 0 ? _a : "",
            html: generatedCode,
            schema: currentSchema !== null && currentSchema !== void 0 ? currentSchema : null,
        });
    }, [selectedForm, currentSchema, selectedForm]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", flexDirection: "column", height: "100vh", children: [(0, jsx_runtime_1.jsx)(Header_1.default, { getUpdatedSessionValues: getSessionValuesToUpdate }), (0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", height: "calc( 100vh - 72px )", flexDirection: { xs: "column", sm: "row" }, children: [(0, jsx_runtime_1.jsx)(LeftSidebar_1.default, {}), (0, jsx_runtime_1.jsx)(MainCanvas_1.default, {}), (0, jsx_runtime_1.jsx)(RightSidebar_1.default, { buildPrompt: buildPromptWrraper, children: (0, jsx_runtime_1.jsx)(SchemaSettings_1.SchemaSettings, {}) })] })] }));
};
exports.UserInterface = UserInterface;
